import { render, staticRenderFns } from "./MemoTagEditDialog.vue?vue&type=template&id=4c777142&scoped=true&"
import script from "./MemoTagEditDialog.vue?vue&type=script&lang=ts&"
export * from "./MemoTagEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MemoTagEditDialog.vue?vue&type=style&index=0&id=4c777142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c777142",
  null
  
)

export default component.exports